export default () => '我的點數';
